import React, { useState, useEffect } from "react";
import "../index.css";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import IntroduceXpageIntro from "./IntroduceXpageIntro";
import QuickStart from "./quickstart";
import SetUpYourBrand from "./quick-launch/SetUpYourBrand";
import GenerateYourLandingPage from "./quick-launch/GenerateYourLP";
import QuickLaunchChecklist from "./quick-launch/QuickLaunchChecklist";
import SetUpYourDomain from "./quick-launch/SetUpYourDomain";
import SetUpYourPayments from "./quick-launch/SetUpYourPayement";
import ReviewShippingPolicies from "./quick-launch/ReviewShippingPolicies";
import FreeTrial from "./pricingPlan/FreeTrial";
import PricingPlans from "./pricingPlan/PricingPlans";
import EntryPlan from "./pricingPlan/EntryPlan";
import GrowthPlan from "./pricingPlan/GrowthPlan";
import ProPlan from "./pricingPlan/ProPlan";
import EnterprisePlan from "./pricingPlan/EnterprisePlan";
import StarterPlan from "./pricingPlan/StarterPlan";
import CreateAccountLandingPage from "./landing-page-setup/CreateYourAccountAndLP";
import Landingpagesetup from "./landing-page-setup/LandingPageSetup";
import CompleteStoreInformation from "./landing-page-setup/CompleteYourxPageStoreInformation";
import AddStaffAndSetPermissions from "./landing-page-setup/AddStaffAndSetPermissions";
import SetUpYourDomainLandingPage from "./landing-page-setup/SetUpYourDomainLandingPage";
import AddYourProducts from "./landing-page-setup/AddYouProduct";
import SetUpPolicyPages from "./landingpageCompilance/SetUpPolicyPages";
import ConfigurePayment from "./landingpageCompilance/configurePayment";
import Landingpagecompliance from "./landingpageCompilance/Landingpagecompliance";
import SetupShippingAndTax from "./landingpageCompilance/SetupShippingAndTax";
import CustomizeYourCheckout from "./landingpageCompilance/CustomizeYourCheckout";
import LaunchYourXpage from "./landingpageCompilance/LaunchYourXpage";
import ViewManageYourBill from "./understand-xpage/ViewManageYourBill";
import LandingpageAccount from "./understand-xpage//LandingpageAccount";
import BillDetails from "./understand-xpage/BillDetails";
import Landingpageaccount from "./landingpageandaccount/Landingpageaccount";
import ManageYourXpageAccount from "./landingpageandaccount/Manage Your Xpage Account ";
import GeneralLandingPageSettings from "./landingpageandaccount/GeneralLandingPageSettings";
import ManageLandingPageBrandAssets from "./landingpageandaccount/ManageLandingPageBrandAssets";
import ChangeYourPlan from "./landingpageandaccount/ChangeYourPlan";
import DeactivateYourStore from "./landingpageandaccount/DeactivateYourStore";
import RolesAndPermissions from "./landingpageandaccount/RolesAndPermissions";
import OnlineStore from "./landingpageandaccount/onlineStore";
import StoreOperation from "./store-operation/StoreOperation";
import Product from "./store-operation/Product";
import DigitalProduct from './store-operation/DigitalProduct'
import GetPayments from "./store-operation/GetPayments";
import OrderFulfillment from "./store-operation/OrderFulfillment";
import Manageorders from "./store-operation/Manageorders";
import ManageCustomer from "./store-operation/ManageCustomer";
import LandingPageGenerate from "./store-operation/LandingPageGenerate";
import Businessexpansion from "./business-expansion/Businessexpansion";
import Reviews from "./business-expansion/Reviews";
import BuyXGetY from "./business-expansion/BuyXGetY";
import FixedBundle from "./business-expansion/FixedBundle";
import DiscountBundle from "./business-expansion/DiscountBundle";
import CodFormXpage from "./business-expansion/CodFormXpage";
import Report from "./business-expansion/Report";
import LiveView from "./business-expansion/LiveView";
import Settings from "./Settings/Settings";
import FraudPrevention from "./Settings/FraudPrevention";
import General from "./Settings/General";
import BrandIdentity from "./Settings/BrandIdentity";
import Plan from "./Settings/Plan";
import Billing from "./Settings/Billing";
import UsersAndPermissions from "./Settings/UsersAndPermissions";
import Payments from "./Settings/Payments";
import Notifications from "./Settings/Notifications";
import CheckoutSettings from "./Settings/CheckoutSettings";
import Domains from "./Settings/Domains";
import TrackingEvents from "./Settings/TrackingEvents";
import Policies from "./Settings/Policies";
import ShippingAndDeliverySettings from "./Settings/ShippingAndDeliverySettings";
import Appss from "./Apps/Apps";
import AvailableApps from "./Apps/AvailableApps"
import SearchforApps from "./Apps/SearchforApps";
import ChoosetheRightApp from "./Apps/ChoosetheRightApp";
import InstallanApp from "./Apps/InstallanApp";
import ManageInstalledApps from "./Apps/ManageInstalledApps";
import ManageAppPermissionsPrivacy from "./Apps/ManageAppPermissionsPrivacy";
import UninstallApps from "./Apps/UninstallApps";
import ChartsAndGraphics from "./business-expansion/ChartsAndGraphics";
import DiscountCodesInXPage from "./business-expansion/DiscountCodesInXPage";
import AutoCurrencyConversion from './business-expansion/AutoCurrencyConversion'
import { slugify } from "../utils/slugify";
const SideBar = () => {
  const { docId, section } = useParams(); // Changed from 'sections' to 'section'
  const location = useLocation();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState("introduction");
  const [isMobile, setIsMobile] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [expandedSections, setExpandedSections] = useState({});

  // Check if mobile on mount and resize
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024);
      if (window.innerWidth >= 1024) {
        setIsSidebarOpen(true);
      } else {
        setIsSidebarOpen(false);
      }
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const findOriginalKey = (map, slug) => {
  return Object.keys(map).find(
    (key) => slugify(key) === slug
  );
};

  // Set active section from URL params
  useEffect(() => {
  if (section) {
    setActiveSection(section); // section from URL is already slugified
  } else {
    const currentItem = sidebarItems.find((item) => slugify(item.id) === docId);
      if (currentItem) {
        const defaultSection = getFirstAvailableSection(currentItem);
        if (defaultSection && defaultSection !== activeSection) {
          setActiveSection(slugify(defaultSection));
          // Navigate to the default section URL
navigate(`/help/${slugify(docId)}/${slugify(defaultSection)}`);        }
      }
    }
  }, [docId, section, navigate]);

  // Get first available section
  const getFirstAvailableSection = (item) => {
    if (!item.sections || item.sections.length === 0) return item.id;

    // Return the main section ID for items with multiple sections
    if (item.sections.length > 1) {
      return item.id;
    }

    // For single-section items
    const firstSection = item.sections[0];
    if (typeof firstSection === "string") {
      return firstSection;
    } else if (firstSection.children && firstSection.children.length > 0) {
      return firstSection.children[0];
    }

    return item.id;
  };

  const toggleSection = (sectionId) => {
    setExpandedSections((prev) => ({
      ...prev,
      [sectionId]: !prev[sectionId],
    }));
  };

  // Handle main category click
  const handleItemClick = (docId) => {
    const item = sidebarItems.find((item) => item.id === docId);
    if (item) {
      const defaultSection = getFirstAvailableSection(item);
      navigate(`/help/${slugify(docId)}/${slugify(defaultSection)}`);;
      setActiveSection(slugify(defaultSection));
      if (isMobile) setIsSidebarOpen(false);
    }
  };

  // Handle section click

  const handleSectionClick = (sectionName) => {
  navigate(`/help/${slugify(docId)}/${slugify(sectionName)}`);
  setActiveSection(slugify(sectionName)); // ✅ slugified
  if (isMobile) setIsSidebarOpen(false);
};

  const sidebarItems = [
    {
      id: "introduce-xpage",
      title: "Introduce xPage",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M48.5833 36.9675V10.3129C48.5833 7.66295 46.4191 5.69753 43.7912 5.91836H43.6587C39.0212 6.31586 31.9766 8.67878 28.0458 11.1521L27.6704 11.395C27.03 11.7925 25.97 11.7925 25.3295 11.395L24.7775 11.0638C20.8466 8.61253 13.8241 6.2717 9.18663 5.89628C6.55871 5.67545 4.41663 7.66295 4.41663 10.2909V36.9675C4.41663 39.0875 6.13913 41.075 8.25913 41.34L8.89954 41.4284C13.6916 42.0688 21.0895 44.4979 25.3295 46.8167L25.4179 46.8609C26.0141 47.1921 26.9637 47.1921 27.5379 46.8609C31.7779 44.52 39.1979 42.0688 44.012 41.4284L44.7408 41.34C46.8608 41.075 48.5833 39.0875 48.5833 36.9675Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.5 12.1238V45.2488"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.1146 18.7488H12.1459"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18.7709 25.3738H12.1459"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      sections: ["introduction"],
    },
    {
      id: "quick-start-guide",
      title: "Quick Start Guide",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M39.75 13.25H13.25C8.38163 13.25 4.41663 17.215 4.41663 22.0833V39.75C4.41663 44.6184 8.38163 48.5833 13.25 48.5833H39.75C44.6184 48.5833 48.5833 44.6184 48.5833 39.75V22.0833C48.5833 17.215 44.6184 13.25 39.75 13.25Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 13.25V9.9375C19.875 7.40167 21.9017 5.375 24.4375 5.375H28.5625C31.0983 5.375 33.125 7.40167 33.125 9.9375V13.25"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 23.1875H33.125"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 30.9166H33.125"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 38.6458H26.5"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M30.9166 38.6458C32.8729 38.6458 34.4583 37.0604 34.4583 35.1041C34.4583 33.1479 32.8729 31.5625 30.9166 31.5625C28.9604 31.5625 27.375 33.1479 27.375 35.1041C27.375 37.0604 28.9604 38.6458 30.9166 38.6458Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      sections: ["overview"],
    },
    {
      id: "pricing-plans",
      title: "Pricing Plans",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M31.4947 35.329H20.453"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M27.9575 5.56084L27.8913 5.71543L21.4871 20.5775H15.1934C13.6917 20.5775 12.2563 20.8867 10.9534 21.4388L14.818 12.2079L14.9063 11.9871L15.0609 11.6338C15.105 11.5013 15.1492 11.3688 15.2155 11.2583C18.1084 4.56709 21.3767 3.04334 27.9575 5.56084Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M39.8604 21.0192C38.8666 20.7101 37.8066 20.5776 36.7466 20.5776H21.4871L27.8912 5.7155L27.9575 5.56091C28.2887 5.67133 28.5979 5.82591 28.9291 5.95841L33.8096 8.01216C36.5258 9.13841 38.425 10.3088 39.5733 11.7222C39.7941 11.9872 39.9708 12.2301 40.1254 12.5172C40.3241 12.8263 40.4787 13.1355 40.5671 13.4667C40.6554 13.6655 40.7216 13.8642 40.7658 14.0409C41.3621 15.8959 41.0087 18.1705 39.8604 21.0192Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M47.5271 31.3547V35.6609C47.5271 36.1026 47.505 36.5443 47.4829 36.9859C47.0633 44.693 42.7571 48.5797 34.5863 48.5797H17.3613C16.8313 48.5797 16.3013 48.5355 15.7933 48.4693C8.77084 48.0055 5.01667 44.2513 4.55292 37.2288C4.48667 36.7209 4.4425 36.1909 4.4425 35.6609V31.3547C4.4425 26.9159 7.13667 23.0955 10.9792 21.4393C12.3042 20.8872 13.7175 20.578 15.2192 20.578H36.7725C37.8546 20.578 38.9146 20.7326 39.8863 21.0197C44.2808 22.3668 47.5271 26.4743 47.5271 31.3547Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.8179 12.208L10.9533 21.4388C7.11079 23.0951 4.41663 26.9155 4.41663 31.3543V24.8838C4.41663 18.6122 8.87746 13.3784 14.8179 12.208Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M47.5202 24.8828V31.3532C47.5202 26.4949 44.2961 22.3653 39.8794 21.0403C41.0277 18.1694 41.359 15.9169 40.8069 14.0399C40.7627 13.8411 40.6965 13.6424 40.6081 13.4657C44.7156 15.5857 47.5202 19.9361 47.5202 24.8828Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      sections: [
        "Free Trial",
        "Entry plan",
        "Starter Plan",
        "Growth Plan",
        "Pro Plan",
        "Enterprise Plan",
      ],
    },
    {
      id: "quick-launch-checklist",
      title: "Quick Launch Checklist",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.72913 39.75V15.4583C7.72913 6.62496 9.93746 4.41663 18.7708 4.41663H34.2291C43.0625 4.41663 45.2708 6.62496 45.2708 15.4583V37.5416C45.2708 37.8508 45.2708 38.16 45.2487 38.4691"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.0229 33.125H45.2708V40.8542C45.2708 45.1162 41.8037 48.5833 37.5416 48.5833H15.4583C11.1962 48.5833 7.72913 45.1162 7.72913 40.8542V39.4188C7.72913 35.9517 10.5558 33.125 14.0229 33.125Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.6666 15.4584H35.3333"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.6666 23.1875H28.7083"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      sections: [
        "Set Up Your Brand",
        "Generate Your Landing Page",
        "Set Up Your Domain",
        "Set Up Your Payments",
        "Review Shipping & Policies",
      ],
    },
    {
      id: "landing-page-setup",
      title: "Landing Page Setup",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M39.75 4.41663H13.25C8.38163 4.41663 4.41663 8.38163 4.41663 13.25V39.75C4.41663 44.6184 8.38163 48.5833 13.25 48.5833H39.75C44.6184 48.5833 48.5833 44.6184 48.5833 39.75V13.25C48.5833 8.38163 44.6184 4.41663 39.75 4.41663Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 19.875H33.125"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 28.7083H33.125"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 37.5416H26.5"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      sections: [
        "Create Your Account and Landing Page",
        "Complete Your xPage Store Information",
        "Add Staff and Set Permissions",
        "Set Up Your Domain",
        "Add Your Products",
      ],
    },
    {
      id: "landing-page-compliance",
      title: "Landing Page Compliance",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.1666 44.1666H13.25C9.00996 44.1666 5.58329 40.74 5.58329 36.5V13.25C5.58329 9.00996 9.00996 5.58329 13.25 5.58329H39.75C43.99 5.58329 47.4166 9.00996 47.4166 13.25V21.1666"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 26.5L24.2917 30.9167L33.125 22.0833"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M39.75 30.9166C43.99 30.9166 47.4166 34.3433 47.4166 38.5833C47.4166 42.8233 43.99 46.25 39.75 46.25C35.51 46.25 32.0833 42.8233 32.0833 38.5833C32.0833 34.3433 35.51 30.9166 39.75 30.9166Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M39.75 34.4729V38.5833H43.8604"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      sections: [
        "Set Up Policy Pages",
        "Set Up Shipping and Tax Rules",
        "Configure Payment and Checkout Process",
        "Customize Your Checkout Settings",
        "Launch Your Xpage Store",
      ],
    },
    {
      id: "understand-xpage",
      title: "Understand xPage",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.5 48.5833C38.6962 48.5833 48.5833 38.6962 48.5833 26.5C48.5833 14.3037 38.6962 4.41663 26.5 4.41663C14.3037 4.41663 4.41663 14.3037 4.41663 26.5C4.41663 38.6962 14.3037 48.5833 26.5 48.5833Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.5 17.6666V26.5L31.9375 31.9375"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      sections: ["Bill Details (What's Included)", "View & Manage Your Bill"],
    },
    {
      id: "landing-page-account",
      title: "Landing Page & Account",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M39.75 13.25H13.25C8.38163 13.25 4.41663 17.215 4.41663 22.0833V39.75C4.41663 44.6184 8.38163 48.5833 13.25 48.5833H39.75C44.6184 48.5833 48.5833 44.6184 48.5833 39.75V22.0833C48.5833 17.215 44.6184 13.25 39.75 13.25Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.25 13.25V9.93746C13.25 6.62496 15.4583 4.41663 18.7708 4.41663H34.2291C37.5416 4.41663 39.75 6.62496 39.75 9.93746V13.25"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.5 35.3333C29.8135 35.3333 32.5 32.6468 32.5 29.3333C32.5 26.0198 29.8135 23.3333 26.5 23.3333C23.1865 23.3333 20.5 26.0198 20.5 29.3333C20.5 32.6468 23.1865 35.3333 26.5 35.3333Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M35.3333 35.3333L33.125 33.125"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      sections: [
        "Manage Your Xpage Account",
        "General Landing Page Settings",
        "Manage Landing Page Brand Assets",
        "Online Store",
        {
          title: "Manage your subscription",
          children: ["Change your plan", "Deactivate your store"],
        },
        "Roles and permissions",
      ],
    },
    {
      id: "store-operation",
      title: "Store Operation",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M39.75 17.6666H13.25C8.38163 17.6666 4.41663 21.6316 4.41663 26.5V39.75C4.41663 44.6184 8.38163 48.5833 13.25 48.5833H39.75C44.6184 48.5833 48.5833 44.6184 48.5833 39.75V26.5C48.5833 21.6316 44.6184 17.6666 39.75 17.6666Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.6666 17.6666V13.25C17.6666 9.00996 21.0933 5.58329 25.3333 5.58329H27.6666C31.9066 5.58329 35.3333 9.00996 35.3333 13.25V17.6666"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.5 35.3333C29.8135 35.3333 32.5 32.6468 32.5 29.3333C32.5 26.0198 29.8135 23.3333 26.5 23.3333C23.1865 23.3333 20.5 26.0198 20.5 29.3333C20.5 32.6468 23.1865 35.3333 26.5 35.3333Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      sections: [
        "Physical Product",
        "Digital Product",
        "Get Payments",
        "Order Fulfillment",
        "Manage orders",
        "Manage Customer",
        "Landing Page Generate",
      ],
    },
    {
      id: "business-expansion",
      title: "Business Expansion",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.5 48.5833C38.6962 48.5833 48.5833 38.6962 48.5833 26.5C48.5833 14.3037 38.6962 4.41663 26.5 4.41663C14.3037 4.41663 4.41663 14.3037 4.41663 26.5C4.41663 38.6962 14.3037 48.5833 26.5 48.5833Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M33.125 19.875L26.5 26.5L19.875 33.125"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M33.125 33.125H19.875V19.875"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      sections: [
        "Reviews",
        {
          title: "Offers & Bundles",
          children: ["Buy X Get Y", "Fixed Bundle", "Discount Bundle"],
        },
        {
          title: "Xpage Analytics",
          children: ["Charts and Graphics", "Report", "Live View"],
        },
        "COD Forms on XPage",
        " Discount Codes in XPage ",
        "Auto Currency Conversion",
      ],
    },
    {
      id: "settings",
      title: "Settings",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.5 31.9375C29.8135 31.9375 32.5 29.251 32.5 25.9375C32.5 22.624 29.8135 19.9375 26.5 19.9375C23.1865 19.9375 20.5 22.624 20.5 25.9375C20.5 29.251 23.1865 31.9375 26.5 31.9375Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M44.1666 31.9375C42.3875 31.9375 41.1458 33.1792 41.1458 34.9583C41.1458 36.7375 42.3875 37.9792 44.1666 37.9792C45.9458 37.9792 47.1875 36.7375 47.1875 34.9583C47.1875 33.1792 45.9458 31.9375 44.1666 31.9375Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.83329 31.9375C7.05413 31.9375 5.81246 33.1792 5.81246 34.9583C5.81246 36.7375 7.05413 37.9792 8.83329 37.9792C10.6125 37.9792 11.8541 36.7375 11.8541 34.9583C11.8541 33.1792 10.6125 31.9375 8.83329 31.9375Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M34.9583 8.83329C34.9583 10.6125 33.7166 11.8541 31.9375 11.8541C30.1583 11.8541 28.9166 10.6125 28.9166 8.83329C28.9166 7.05413 30.1583 5.81246 31.9375 5.81246C33.7166 5.81246 34.9583 7.05413 34.9583 8.83329Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M34.9583 44.1666C34.9583 45.9458 33.7166 47.1875 31.9375 47.1875C30.1583 47.1875 28.9166 45.9458 28.9166 44.1666C28.9166 42.3875 30.1583 41.1458 31.9375 41.1458C33.7166 41.1458 34.9583 42.3875 34.9583 44.1666Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 13.25L23.1875 15.4583L29.3333 11.8542"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 37.9792L23.1875 35.7708L29.3333 39.375"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      sections: [
        "General",
        "Brand Identity",
        "Plan",
        "Billing",
        "Users & Permissions",
        "Payments",
        "Notifications",
        "Fraud Prevention",
        "Checkout Settings",
        "Domains",
        "Tracking Events",
        "Policies",
        "Shipping & Delivery Settings",
      ],
    },
    {
      id: "apps",
      title: "Apps",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M39.75 13.25H13.25C8.38163 13.25 4.41663 17.215 4.41663 22.0833V39.75C4.41663 44.6184 8.38163 48.5833 13.25 48.5833H39.75C44.6184 48.5833 48.5833 44.6184 48.5833 39.75V22.0833C48.5833 17.215 44.6184 13.25 39.75 13.25Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.6666 8.83329V17.6666"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M35.3333 8.83329V17.6666"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 26.5H33.125"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 33.125H28.7083"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      sections: [
        "Available Apps",
        "Search for Apps",
        "Choose the Right App",
        "Install an App",
        "Manage Installed Apps",
        "Manage App Permissions & Privacy",
        "Uninstall Apps",
      ],
    },
  ];

  const contentComponents = {
    "introduce-xpage": {
      introduction: <IntroduceXpageIntro />,
    },
    "quick-start-guide": {
      overview: <QuickStart />,
    },
    "pricing-plans": {
      "pricing-plans": <PricingPlans />,
      "Free Trial": <FreeTrial />,
      "Entry plan": <EntryPlan />,
      "Starter Plan": <StarterPlan />,
      "Growth Plan": <GrowthPlan />,
      "Pro Plan": <ProPlan />,
      "Enterprise Plan": <EnterprisePlan />,
    },
    "quick-launch-checklist": {
      "quick-launch-checklist": <QuickLaunchChecklist />,
      "Set Up Your Brand": <SetUpYourBrand />,
      "Generate Your Landing Page": <GenerateYourLandingPage />,
      "Set Up Your Domain": <SetUpYourDomain />,
      "Set Up Your Payments": <SetUpYourPayments />,
      "Review Shipping & Policies": <ReviewShippingPolicies />,
    },
    "landing-page-setup": {
      "landing-page-setup": <Landingpagesetup />,
      "Create Your Account and Landing Page": <CreateAccountLandingPage />,
      "Complete Your xPage Store Information": <CompleteStoreInformation />,
      "Add Staff and Set Permissions": <AddStaffAndSetPermissions />,
      "Set Up Your Domain": <SetUpYourDomainLandingPage />,
      "Add Your Products": <AddYourProducts />,
    },
    "landing-page-compliance": {
      "landing-page-compliance": <Landingpagecompliance />,
      "Set Up Policy Pages": <SetUpPolicyPages />,
      "Set Up Shipping and Tax Rules": <SetupShippingAndTax />,
      "Configure Payment and Checkout Process": <ConfigurePayment />,
      "Customize Your Checkout Settings": <CustomizeYourCheckout />,
      "Launch Your Xpage Store": <LaunchYourXpage />,
    },
    "understand-xpage": {
      "understand-xpage": <LandingpageAccount />,
      "Bill Details (What's Included)": <BillDetails />,
      "View & Manage Your Bill": <ViewManageYourBill />,
    },
    "landing-page-account": {
      "landing-page-account": <Landingpageaccount />,
      "Manage Your Xpage Account": <ManageYourXpageAccount />,
      "General Landing Page Settings": <GeneralLandingPageSettings />,
      "Manage Landing Page Brand Assets": <ManageLandingPageBrandAssets />,
      "Online Store": <OnlineStore />,
      "Change your plan": <ChangeYourPlan />,
      "Deactivate your store": <DeactivateYourStore />,
      "Roles and permissions": <RolesAndPermissions />,
    },
    "store-operation": {
      "store-operation": <StoreOperation />,
      "Physical Product": <Product />,
      "Digital Product": <DigitalProduct />,
      "Get Payments": <GetPayments />,
      "Order Fulfillment": <OrderFulfillment />,
      "Manage orders": <Manageorders />,
      "Manage Customer": <ManageCustomer />,
      "Landing Page Generate": <LandingPageGenerate />,
    },
    "business-expansion": {
      "business-expansion": <Businessexpansion />,
      "Reviews": <Reviews />,
      "Buy X Get Y": <BuyXGetY />,
      "Fixed Bundle": <FixedBundle />,
      "Discount Bundle": <DiscountBundle />,
      "Charts and Graphics": <ChartsAndGraphics />,
      "Report": <Report />,
      "Live View": <LiveView />,
      "COD Forms on XPage": <CodFormXpage />,
      " Discount Codes in XPage ": <DiscountCodesInXPage />,
      "Auto Currency Conversion":<AutoCurrencyConversion />
    },
    settings: {
      settings: <Settings />,
      General: <General />,
      "Brand Identity": <BrandIdentity />,
      Plan: <Plan />,
      Billing: <Billing />,
      "Users & Permissions": <UsersAndPermissions />,
      Payments: <Payments />,
      Notifications: <Notifications />,
      "Fraud Prevention": <FraudPrevention />,
      "Checkout Settings": <CheckoutSettings />,
      Domains: <Domains />,
      "Tracking Events": <TrackingEvents />,
      Policies: <Policies />,
      "Shipping & Delivery Settings": <ShippingAndDeliverySettings />,
    },
    apps: {
      "Available Apps" :<AvailableApps/>,
      apps: <Appss />,
      "Search for Apps": <SearchforApps />,
      "Choose the Right App": <ChoosetheRightApp />,
      "Install an App": <InstallanApp />,
      "Manage Installed Apps": <ManageInstalledApps />,
      "Manage App Permissions & Privacy": <ManageAppPermissionsPrivacy />,
      "Uninstall Apps": <UninstallApps />,
    },
  };

  const currentItem =
    sidebarItems.find((item) => item.id === docId) || sidebarItems[0];
const docKey = findOriginalKey(contentComponents, docId);
const sectionKey = findOriginalKey(contentComponents[docKey] || {}, activeSection);

const CurrentContent = contentComponents?.[docKey]?.[sectionKey];
  const renderSections = (sections, parentId = "") => {
    return sections.map((sectionItem, index) => {
      const sectionKey = parentId ? `${parentId}-${index}` : `${index}`;

      if (typeof sectionItem === "string") {
        return (
          <li key={sectionKey}>
            <button
              onClick={() => handleSectionClick(sectionItem)}
              className={`w-full text-left px-3 py-2 rounded text-sm transition-colors duration-200 flex items-center ${
                activeSection === slugify(sectionItem)
                  ? "text-deepPurple font-medium bg-deepPurple/5 border-l-2 border-deepPurple"
                  : "text-systemLabel hover:text-systemTitle"
              }`}
            >
              <div
                className={`w-1.5 h-1.5 rounded-full mr-3 ${
                  activeSection === slugify(sectionItem)
                    ? "bg-deepPurple"
                    : "bg-systemBorder"
                }`}
              ></div>
              {sectionItem}
            </button>
          </li>
        );
      } else if (sectionItem.children) {
        return (
          <li key={sectionKey}>
            <button
              onClick={() => toggleSection(sectionKey)}
              className="w-full text-left px-3 py-2 rounded text-sm transition-colors duration-200 flex items-center justify-between text-systemLabel hover:text-systemTitle"
            >
              <div className="flex items-center">
                <div className="w-1.5 h-1.5 rounded-full bg-systemBorder mr-3"></div>
                {sectionItem.title}
              </div>
              <svg
                className={`w-4 h-4 transition-transform duration-200 ${
                  expandedSections[sectionKey] ? "rotate-180" : ""
                }`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>
            {expandedSections[sectionKey] && (
              <ul className="ml-6 mt-1 space-y-1 border-l border-systemBorder">
                {sectionItem.children.map((child, childIndex) => (
                  <li key={`${sectionKey}-child-${childIndex}`}>
                    <button
                      onClick={() => handleSectionClick(child)}
                      className={`w-full text-left px-3 py-2 rounded text-sm transition-colors duration-200 flex items-center ${
                        activeSection === slugify(child)
                          ? "text-deepPurple font-medium bg-deepPurple/5"
                          : "text-systemLabel hover:text-systemTitle"
                      }`}
                    >
                      <div
                        className={`w-1.5 h-1.5 rounded-full mr-3 ${
                          activeSection === slugify(child)
                            ? "bg-deepPurple"
                            : "bg-systemBorder"
                        }`}
                      ></div>
                      {child}
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </li>
        );
      }
      return null;
    });
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Mobile Header */}
      {isMobile && (
        <div className="lg:hidden  border-b border-systemBorder p-4 sticky top-0 z-40 bg-systemBackground">
          <div className="flex items-center justify-between">
            <button
              onClick={() => setIsSidebarOpen(!isSidebarOpen)}
              className="p-2 rounded-lg border border-systemBorder  hover:bg-systemBackground transition-colors"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3 12H21"
                  stroke="#5F3164"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M3 6H21"
                  stroke="#5F3164"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M3 18H21"
                  stroke="#5F3164"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <div className="w-10"></div>
          </div>
        </div>
      )}

      <div className="flex">
        {/* Sidebar */}
        <div
          className={`
                    ${isMobile ? "fixed inset-y-0 bg-systemBackground left-0 z-50 transform transition-transform duration-300 ease-in-out" : "fixed left-0 top-0 z-30"} 
                    ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"} 
                    lg:translate-x-0
                    w-[280px] lg:w-[300px]  border-r border-systemBorder h-screen
                    overflow-y-auto sidebar-scroll
                    flex-shrink-0
                `}
        >
          {/* Close button for mobile */}
          {isMobile && (
            <div className="flex justify-end p-4 lg:hidden">
              <button
                onClick={() => setIsSidebarOpen(false)}
                className="p-2 rounded-lg border border-systemBorder  hover:bg-systemBackground transition-colors"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18 6L6 18"
                    stroke="#5F3164"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M6 6L18 18"
                    stroke="#5F3164"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
          )}

          <div className="p-4 lg:p-6 border-b border-systemBorder">
            <div className="flex items-center justify-center gap-2">
              <a href="/">
                <svg
                  width="80"
                  height="30"
                  viewBox="0 0 365 135"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M105.675 30.3704L70.4136 67.2819C65.7535 72.1601 59.433 74.9006 52.8426 74.9006C46.2522 74.9006 39.9317 72.1601 35.2716 67.2819L79.6161 20.8628C80.7295 19.696 82.0517 18.7701 83.5069 18.1381C84.9622 17.5061 86.5221 17.1803 88.0977 17.1794C89.6732 17.1785 91.2335 17.5024 92.6895 18.1327C94.1454 18.7629 95.4685 19.6872 96.5832 20.8528L105.675 30.3704Z"
                    fill="url(#paint0_linear_3830_94)"
                  />
                  <path
                    d="M0.014428 104.188L26.7256 76.2274L44.2966 94.6205L26.0834 113.686C23.8334 116.041 20.7818 117.364 17.5998 117.364C14.4179 117.364 11.3662 116.041 9.11626 113.686L0.00962301 104.153L0.014428 104.188Z"
                    fill="#7C54D2"
                  />
                  <path
                    d="M26.0594 20.8626L70.4039 67.2818C68.0975 69.7 65.3586 71.6188 62.3435 72.9286C59.3285 74.2385 56.0964 74.9136 52.8321 74.9155C49.5677 74.9173 46.3349 74.2459 43.3185 72.9395C40.3021 71.6331 37.5611 69.7174 35.2523 67.3018L0 30.4003L9.10664 20.8676C11.3554 18.5163 14.4036 17.1952 17.582 17.1943C20.7604 17.1933 23.8093 18.5127 26.0594 20.8626Z"
                    fill="url(#paint1_linear_3830_94)"
                  />
                  <path
                    d="M79.0308 76.3031L105.665 104.184L96.5586 113.716C94.3087 116.072 91.257 117.395 88.0751 117.395C84.8932 117.395 81.8415 116.072 79.5915 113.716L61.4406 94.7162L79.0308 76.3031Z"
                    fill="#7C54D2"
                  />
                  <path
                    d="M125.096 108V26.9341H155.496C161.723 26.9341 166.948 28.0952 171.171 30.4174C175.419 32.7396 178.625 35.9326 180.789 39.9965C182.979 44.034 184.075 48.6256 184.075 53.7714C184.075 58.97 182.979 63.588 180.789 67.6255C178.599 71.6629 175.366 74.8428 171.091 77.165C166.816 79.4608 161.552 80.6087 155.298 80.6087H135.15V68.5359H153.319C156.96 68.5359 159.942 67.9025 162.264 66.6359C164.587 65.3692 166.302 63.6276 167.41 61.4109C168.545 59.1943 169.112 56.6478 169.112 53.7714C169.112 50.895 168.545 48.3617 167.41 46.1714C166.302 43.9812 164.573 42.2791 162.225 41.0652C159.903 39.825 156.907 39.2048 153.239 39.2048H139.781V108H125.096ZM204.801 109.227C200.949 109.227 197.479 108.541 194.391 107.169C191.33 105.77 188.902 103.712 187.108 100.994C185.34 98.2759 184.456 94.9246 184.456 90.9399C184.456 87.5093 185.089 84.6726 186.356 82.4295C187.622 80.1865 189.351 78.392 191.541 77.0462C193.731 75.7004 196.199 74.6844 198.943 73.9983C201.714 73.2858 204.577 72.7713 207.533 72.4546C211.095 72.0851 213.985 71.7553 216.201 71.465C218.418 71.1484 220.028 70.6734 221.031 70.04C222.06 69.3803 222.574 68.3643 222.574 66.9921V66.7546C222.574 63.7727 221.69 61.4637 219.922 59.8276C218.154 58.1915 215.608 57.3735 212.283 57.3735C208.773 57.3735 205.989 58.1387 203.931 59.6693C201.899 61.1998 200.527 63.0074 199.814 65.0921L186.435 63.1922C187.491 59.4977 189.232 56.4103 191.66 53.9297C194.088 51.4228 197.056 49.5492 200.566 48.3089C204.076 47.0423 207.955 46.4089 212.204 46.4089C215.133 46.4089 218.049 46.752 220.951 47.4381C223.854 48.1242 226.506 49.2589 228.908 50.8422C231.309 52.3992 233.235 54.5235 234.687 57.2151C236.164 59.9068 236.903 63.2713 236.903 67.3088V108H223.128V99.6481H222.653C221.783 101.337 220.556 102.92 218.972 104.398C217.415 105.849 215.449 107.024 213.074 107.921C210.726 108.792 207.968 109.227 204.801 109.227ZM208.522 98.6982C211.399 98.6982 213.892 98.1308 216.003 96.9961C218.115 95.835 219.737 94.3044 220.872 92.4044C222.033 90.5045 222.614 88.4329 222.614 86.1899V79.0254C222.165 79.3948 221.4 79.7379 220.318 80.0545C219.262 80.3712 218.075 80.6483 216.756 80.8858C215.436 81.1233 214.13 81.3344 212.837 81.5191C211.544 81.7038 210.422 81.8622 209.472 81.9941C207.335 82.2844 205.422 82.7594 203.733 83.4191C202.044 84.0788 200.711 85.0024 199.735 86.1899C198.758 87.351 198.27 88.8552 198.27 90.7024C198.27 93.3412 199.233 95.3336 201.16 96.6794C203.086 98.0252 205.54 98.6982 208.522 98.6982ZM269.95 132.067C264.805 132.067 260.385 131.367 256.69 129.969C252.996 128.597 250.027 126.749 247.784 124.427C245.541 122.105 243.984 119.532 243.113 116.708L256.017 113.581C256.598 114.769 257.442 115.943 258.551 117.104C259.659 118.292 261.15 119.268 263.023 120.033C264.923 120.825 267.312 121.221 270.188 121.221C274.252 121.221 277.616 120.231 280.282 118.252C282.947 116.299 284.279 113.08 284.279 108.594V97.0752H283.567C282.828 98.553 281.746 100.07 280.321 101.627C278.923 103.184 277.062 104.49 274.74 105.546C272.444 106.602 269.555 107.129 266.071 107.129C261.4 107.129 257.165 106.034 253.365 103.844C249.592 101.627 246.583 98.3287 244.34 93.9482C242.124 89.5413 241.015 84.026 241.015 77.4025C241.015 70.7261 242.124 65.0921 244.34 60.5005C246.583 55.8825 249.605 52.386 253.405 50.011C257.205 47.6096 261.44 46.4089 266.111 46.4089C269.673 46.4089 272.602 47.0159 274.898 48.2298C277.221 49.4173 279.068 50.8554 280.44 52.5443C281.812 54.2068 282.855 55.7769 283.567 57.2547H284.359V47.2006H298.49V108.99C298.49 114.188 297.25 118.49 294.769 121.894C292.288 125.298 288.898 127.844 284.596 129.533C280.295 131.222 275.413 132.067 269.95 132.067ZM270.069 95.8878C273.104 95.8878 275.69 95.1489 277.827 93.6711C279.965 92.1933 281.588 90.069 282.696 87.2982C283.804 84.5274 284.359 81.2024 284.359 77.3233C284.359 73.4969 283.804 70.1456 282.696 67.2692C281.614 64.3928 280.005 62.163 277.867 60.5797C275.756 58.97 273.157 58.1651 270.069 58.1651C266.876 58.1651 264.211 58.9964 262.073 60.6588C259.936 62.3213 258.326 64.604 257.244 67.5067C256.162 70.3831 255.621 73.6553 255.621 77.3233C255.621 81.0441 256.162 84.3031 257.244 87.1003C258.353 89.8711 259.976 92.035 262.113 93.5919C264.277 95.1225 266.929 95.8878 270.069 95.8878ZM332.289 109.188C326.193 109.188 320.929 107.921 316.495 105.388C312.088 102.828 308.697 99.2127 306.322 94.5419C303.948 89.8447 302.76 84.3163 302.76 77.9566C302.76 71.7025 303.948 66.2137 306.322 61.4901C308.724 56.7401 312.075 53.0457 316.377 50.4068C320.678 47.7416 325.731 46.4089 331.537 46.4089C335.284 46.4089 338.82 47.0159 342.145 48.2298C345.497 49.4173 348.452 51.2645 351.012 53.7714C353.598 56.2783 355.63 59.4714 357.108 63.3505C358.585 67.2032 359.324 71.7949 359.324 77.1254V81.5191H309.489V71.8608H345.589C345.562 69.1164 344.969 66.6755 343.808 64.538C342.647 62.3741 341.024 60.672 338.939 59.4318C336.881 58.1915 334.479 57.5714 331.735 57.5714C328.806 57.5714 326.233 58.2839 324.016 59.7088C321.799 61.1075 320.071 62.9547 318.831 65.2505C317.617 67.5199 316.997 70.0136 316.97 72.7317V81.1629C316.97 84.6989 317.617 87.7336 318.91 90.267C320.203 92.7739 322.011 94.7003 324.333 96.0461C326.655 97.3655 329.373 98.0252 332.487 98.0252C334.572 98.0252 336.458 97.735 338.147 97.1544C339.836 96.5475 341.301 95.6635 342.541 94.5023C343.781 93.3412 344.718 91.9031 345.351 90.1878L358.73 91.692C357.886 95.228 356.276 98.3155 353.901 100.954C351.553 103.567 348.544 105.599 344.876 107.05C341.208 108.475 337.013 109.188 332.289 109.188Z"
                    fill="#101828"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_3830_94"
                      x1="0"
                      y1="67.287"
                      x2="105.675"
                      y2="67.287"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#7F56D9" />
                      <stop offset="1" stop-color="#D746EE" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_3830_94"
                      x1="0"
                      y1="67.287"
                      x2="105.675"
                      y2="67.287"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#7F56D9" />
                      <stop offset="1" stop-color="#D746EE" />
                    </linearGradient>
                  </defs>
                </svg>
              </a>
              <div className="bg-gradient-to-r from-deepPurple/5 to-deepPurple/10 px-3 py-1 border border-systemBorder rounded-lg">
                <h2 className="text-xs font-semibold text-deepPurple">
                  Help Center
                </h2>
              </div>
            </div>
          </div>

          <nav className="p-3">
            <ul className="space-y-1">
              {sidebarItems.map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => handleItemClick(item.id)}
                    className={`w-full text-left px-3 py-2 rounded-lg transition-colors duration-200 flex items-center space-x-2 ${
                      docId === slugify(item.id)
                        ? "bg-deepPurple/5 text-systemLabel border border-deepPurple/5"
                        : "text-systemLabel hover:text-systemTitle"
                    }`}
                  >
                    <span className="text-base flex-shrink-0">{item.icon}</span>
                    <span className="text-systemTitle font-medium text-sm">
                      {item.title}
                    </span>
                  </button>

                  {/* Sub-sections */}
                  {docId === slugify(item.id) &&
                    !(
                      item.sections.length === 1 &&
                      typeof item.sections[0] === "string"
                    ) && (
                      <ul className="ml-3 lg:ml-6 mt-1 space-y-0.5">
                        {renderSections(item.sections, item.id)}
                      </ul>
                    )}
                </li>
              ))}
            </ul>
          </nav>
        </div>

        {/* Overlay for mobile when sidebar is open */}
        {isMobile && isSidebarOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
            onClick={() => setIsSidebarOpen(false)}
          />
        )}

        {/* Main Content */}
        <div className=" flex-1 min-w-0 lg:ml-[300px] bg-systemBackground">
          <div className="p-4 lg:p-8">
            <div className="max-w-screen-2xl mx-auto">
              <div className="mb-8 lg:mb-12">
                {/* Optional: Add breadcrumb or page title here */}
              </div>
              <div className="">
                {CurrentContent || (
                  <div className="text-center py-12">
                    <h2 className="text-xl font-semibold text-systemTitle mb-2">
                      Content Not Found
                    </h2>
                    <p className="text-systemLabel">
                      No content available for {activeSection}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
